import activityTracker from './tracker';

export { getUtmParams, recordSignUp } from './signUp';
export {
  getCreatedScenarioId,
  trackEditsSuggested,
  trackGameListChanged,
  trackProjectionsRequested,
  trackReportGenerated,
  trackReportRefreshed,
  trackReportShared,
  trackScenarioCreated,
  trackSuggestionsReviewed,
} from './actions';
export type { ViewDetails } from './types';

export default activityTracker;
